import instance from "../../axios/axios-user";
import { PostsProps } from "../../redux/slices/posts/Posts";
import { RepostProps } from "../../redux/slices/posts/Repost";
import { API_PATHS } from "../api_paths";

const createPostDraft = () =>
  instance(API_PATHS.posts.createPostDraft, { method: "POST" });

const activateAPost = (data: PostsProps.activateAPostPayload) =>
  instance(API_PATHS.posts.activateAPost, { method: "POST", data });

const repostAPost = (data: RepostProps.repostAPostPayload) =>
  instance(API_PATHS.posts.repostAPost, { method: "POST", data });

const getSinglePost = (data: PostsProps.getSinglePostPayload) =>
  instance(API_PATHS.posts.post + data.post_id);

const uploadsImageForAPost = (
  data: PostsProps.uploadsImageForAPostPayloadForInstance
) => {
  const formData = new FormData();
  formData.append("image", data.image);

  return instance(API_PATHS.posts.post + data.post_id + "/image", {
    method: "POST",
    headers: {
      "content-type": "multipart/form-data",
    },
    data: formData,
  });
};

const deleteAnImageForAPost = (data: PostsProps.deleteAnImageForAPostPayload) =>
  instance(API_PATHS.posts.post + data.post_id + "/image/" + data.image_id, {
    method: "DELETE",
  });

const deleteAllImagesForAPost = (
  data: PostsProps.deleteAllImagesForAPostPayload
) =>
  instance(API_PATHS.posts.post + data.post_id + "/images", {
    method: "DELETE",
  });

const getUserPosts = (data: PostsProps.getUserPostsPayload) =>
  instance(API_PATHS.posts.userPosts, { data });

const submitAnswerForARateInteraction = (
  data: PostsProps.submitAnswerForARateInteractionPayload
) => {
  const baseURL = API_PATHS.posts.rateInteractions;
  const { slider_id: rate_id } = data;
  return instance.post(`${baseURL}/${rate_id}/answer`, data);
};

export const POSTS = {
  createPostDraft,
  activateAPost,
  repostAPost,
  getSinglePost,
  uploadsImageForAPost,
  deleteAnImageForAPost,
  deleteAllImagesForAPost,
  getUserPosts,
  submitAnswerForARateInteraction,
};
